// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__X1DZF","requiredAsterisk":"Info_requiredAsterisk__22vI5"};